import { render } from "./CheckCrossText.vue?vue&type=template&id=f119f49e&scoped=true"
import script from "./CheckCrossText.vue?vue&type=script&lang=js"
export * from "./CheckCrossText.vue?vue&type=script&lang=js"

import "./CheckCrossText.vue?vue&type=style&index=0&id=f119f49e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f119f49e"]])

export default __exports__